import { render, staticRenderFns } from "./RegisterV2.vue?vue&type=template&id=1079f3c4&scoped=true"
import script from "./RegisterV2.vue?vue&type=script&lang=js"
export * from "./RegisterV2.vue?vue&type=script&lang=js"
import style0 from "./RegisterV2.vue?vue&type=style&index=0&id=1079f3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1079f3c4",
  null
  
)

export default component.exports